export const theme = {
  token: {
    colorPrimary: "#4682e5",
  },
};
